"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Ellipsis_1 = __importDefault(require("../Ellipsis/Ellipsis"));
var RightBoundary = /** @class */ (function (_super) {
    __extends(RightBoundary, _super);
    function RightBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genClasses = function (isDisable) {
            var _a = _this.props, isActive = _a.isActive, totalPages = _a.totalPages;
            var classes = "last-btn page-btn " + isActive(totalPages);
            classes += isDisable ? ' disable' : '';
            return classes;
        };
        _this.genPenultimatePageAndEllipsis = function () {
            var _a = _this.props, ellipsisToggle = _a.ellipsisToggle, onPageChangeHandle = _a.onPageChangeHandle, onEllipsisClick = _a.onEllipsisClick, expandEllipsis = _a.expandEllipsis;
            return (React.createElement(Ellipsis_1.default, { expandEllipsis: expandEllipsis, ellipsisToggle: ellipsisToggle, options: _this.genOptions(), onClick: function () { return onEllipsisClick(); }, onPageChangeHandle: onPageChangeHandle }));
        };
        _this.genOptions = function () {
            var _a = _this.props, lastPageInRange = _a.lastPageInRange, totalPages = _a.totalPages, alphabetical = _a.alphabetical, disabledPages = _a.disabledPages;
            var options = [];
            var _loop_1 = function (page) {
                var option = { value: page, text: '' };
                if (alphabetical) {
                    option.text = String.fromCharCode(96 + page).toUpperCase();
                }
                else {
                    option.text = (page).toString();
                }
                if (disabledPages) {
                    disabledPages.forEach(function (element) {
                        if (element === page) {
                            option.disabled = true;
                        }
                    });
                }
                options.push(option);
            };
            for (var page = lastPageInRange + 2; page < totalPages; page++) {
                _loop_1(page);
            }
            return options;
        };
        return _this;
    }
    RightBoundary.prototype.render = function () {
        var _a = this.props, alphabetical = _a.alphabetical, totalPages = _a.totalPages, onPageChangeHandle = _a.onPageChangeHandle, isPageDisabled = _a.isPageDisabled;
        var value = alphabetical ? 'Z' : totalPages;
        var isDisable = isPageDisabled(value);
        return (React.createElement(React.Fragment, null,
            this.genPenultimatePageAndEllipsis(),
            React.createElement("div", { className: "" + this.genClasses(isDisable), onClick: function () {
                    if (!isDisable) {
                        onPageChangeHandle(totalPages);
                    }
                } }, value)));
    };
    return RightBoundary;
}(React.Component));
exports.default = RightBoundary;
